var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-menu-notifications-date-divider"},[_c('BravadoText',{attrs:{"variant":"subhead-semibold"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }